import { utcTimestamp } from '../format';
import type { KeyListOut } from '../types';

/**
 * M6 adds a cached daily time series that will legitimately disagree with these
 * numbers (different upstream pipeline, different period semantics). Saying where
 * the figures came from now is what stops that being reported as a bug later.
 */
export function Provenance({ list }: { list: KeyListOut }) {
  const live = list.source === 'live';
  return (
    <div
      className={`provenance${list.stale ? ' provenance-stale' : ''}`}
      data-testid="provenance"
    >
      <span className={`dot ${live && !list.stale ? 'dot-live' : 'dot-cache'}`} aria-hidden="true" />
      <span className="provenance-main">
        {live ? 'Current period (live)' : 'Current period (cached)'}
      </span>
      <span className="provenance-meta">
        {live
          ? 'read directly from the OpenRouter key objects'
          : list.stale
            ? 'served from our cache because OpenRouter could not be reached'
            : 'served from our cache; refresh to read OpenRouter directly'}
        {' - '}
        {list.fetched_at ? `last synced ${utcTimestamp(list.fetched_at)}` : 'never synced'}
      </span>
      {list.stale ? <span className="badge badge-warning">Stale</span> : null}
    </div>
  );
}
